/* One-tap add from a product card. Same request Dawn's product-form.js makes,
   so the cart drawer re-renders and opens exactly as it does on the PDP. */
(() => {
  if (window.ssQuickSizes) return;
  window.ssQuickSizes = true;

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-ss-qs-open]');
    if (!open) return;
    event.preventDefault();
    event.stopPropagation();
    // Dawn's opener lives in the (visually hidden) quick-add block of the same card.
    open.closest('.card-wrapper')?.querySelector('.quick-add modal-opener button')?.click();
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.ss-qs__size');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();

    const wrap = button.closest('[data-ss-qs]');
    const label = wrap.querySelector('[data-ss-qs-label]');
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    wrap.classList.add('is-busy');
    button.setAttribute('aria-busy', 'true');

    const body = new FormData();
    body.append('id', button.dataset.variantId);
    body.append('quantity', '1');
    if (cart) {
      body.append('sections', cart.getSectionsToRender().map((s) => s.id));
      body.append('sections_url', window.location.pathname);
      cart.setActiveElement(button);
    }

    try {
      const response = await fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const state = await response.json();
      if (state.status) throw new Error(state.description || state.message);
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ss-quick-sizes', productVariantId: button.dataset.variantId, cartData: state });
      }
      if (cart) {
        cart.classList.contains('is-empty') && cart.classList.remove('is-empty');
        cart.renderContents(state);
      } else {
        window.location = window.routes.cart_url;
      }
      label.textContent = `Added ${button.textContent.trim()}`;
    } catch (error) {
      label.textContent = error.message || 'Could not add. Try again.';
    } finally {
      wrap.classList.remove('is-busy');
      button.removeAttribute('aria-busy');
      setTimeout(() => { label.textContent = 'Quick add'; }, 2400);
    }
  });
})();
